import { render } from "./generalMasterData.vue?vue&type=template&id=e2c393cc&scoped=true"
import script from "./generalMasterData.vue?vue&type=script&lang=js"
export * from "./generalMasterData.vue?vue&type=script&lang=js"

import "./generalMasterData.vue?vue&type=style&index=0&id=e2c393cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c393cc"]])

export default __exports__